// app/views/components/shared/DocumentSection.tsx
import { DocumentUploader } from '@/components/shared/DocumentUploader'
import { TemplateList } from '@/components/shared/TemplateList'

type DocumentAttachment = {
  id: string
  name: string
  blob_signed_id?: string | null
  filename?: string | null
  content_type?: string | null
  created_at?: string
}

type DocumentCategory = {
  label: string
  documents: DocumentAttachment[]
  uploadPath?: string
  /** Base path for deleting documents — docId is appended as `${deletePath}/${docId}` */
  deletePath?: string
}

type DocumentSectionProps = {
  categories: DocumentCategory[]
  templates?: { id: string; name: string; file_url: string | null }[]
  templateUploadPath?: string
  templateDeletePath?: string
}

export function DocumentSection({ categories, templates, templateUploadPath, templateDeletePath }: DocumentSectionProps) {
  return (
    <div className="space-y-4">
      {categories.map(cat => (
        <DocumentUploader
          key={cat.label}
          title={cat.label}
          documents={cat.documents}
          uploadPath={cat.uploadPath || ''}
          deletePath={cat.deletePath ? (docId: string) => `${cat.deletePath}/${docId}` : (_docId: string) => ''}
        />
      ))}
      {templates && templates.length > 0 && (
        <TemplateList title="Document templates" templates={templates} />
      )}
      {templateUploadPath && (
        <DocumentUploader
          title="Upload Template"
          documents={[]}
          uploadPath={templateUploadPath}
          deletePath={templateDeletePath ? (docId: string) => `${templateDeletePath}/${docId}` : (_docId: string) => ''}
        />
      )}
    </div>
  )
}
